import { useMemo, useState } from "react";
import { origemKey } from "./backupOrigem";

// Filtro (empresa + período + status + origem) e ordenação por data do histórico de backups.
// Client-side: a listagem já vem completa (≤ 500 registros). Padrão: mais recente primeiro.
export function useBackupHistoryFilter(files) {
  const [empresaId, setEmpresaId] = useState("all");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [status, setStatus] = useState("all");
  const [origem, setOrigem] = useState("all");
  const [sortDir, setSortDir] = useState("desc");

  const filtered = useMemo(() => {
    const startMs = start ? new Date(`${start}T00:00:00`).getTime() : null;
    const endMs = end ? new Date(`${end}T23:59:59.999`).getTime() : null;
    const list = (files || []).filter((f) => {
      if (empresaId !== "all" && f.empresa_id !== empresaId) return false;
      if (status !== "all" && (f.status || "unknown") !== status) return false;
      if (origem !== "all" && origemKey(f.source) !== origem) return false;
      const t = f.modified_at ? new Date(f.modified_at).getTime() : 0;
      if (startMs != null && t < startMs) return false;
      if (endMs != null && t > endMs) return false;
      return true;
    });
    const dir = sortDir === "asc" ? 1 : -1;
    return list.sort((a, b) => (new Date(a.modified_at || 0) - new Date(b.modified_at || 0)) * dir);
  }, [files, empresaId, start, end, status, origem, sortDir]);

  const toggleSort = () => setSortDir((d) => (d === "desc" ? "asc" : "desc"));
  const clear = () => { setEmpresaId("all"); setStart(""); setEnd(""); setStatus("all"); setOrigem("all"); };
  const active = (empresaId !== "all" ? 1 : 0) + (start ? 1 : 0) + (end ? 1 : 0) + (status !== "all" ? 1 : 0) + (origem !== "all" ? 1 : 0);
  const invalid = !!(start && end && start > end);

  return {
    filtered, empresaId, setEmpresaId, start, setStart, end, setEnd,
    status, setStatus, origem, setOrigem, sortDir, toggleSort, clear, active, invalid,
  };
}
